import styles from './card.module.scss';

export const Card = ({ children, ...props }) => {
  return (
    <div className={styles['card-container']} {...props}>
      {children}
    </div>
  );
};
